import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import "./style.scss";
import uris from "../../../config/uris";
import Breadcrumbs from "../../../assets/component/breadcrumbs";
import CustomTab from "../../../assets/component/tab";
import PlaybookMain, { fetchStoredTabs } from "../../esg-chat/playbooks";

const tabOptions = {
    key: 1,
    title: 'Frameworks',
    value: 'frameworks',
    tabs: [
        {
            key: 1.1,
            title: 'TCFD',
            payloadType: "TCFD",
        },
        {
            key: 1.2,
            title: 'SDG',
            payloadType: "SDG",
        },
        {
            key: 1.3,
            title: 'GRESB',
            payloadType: "GRESB",
        },
        {
            key: 1.4,
            title: 'EcoVadis',
            payloadType: "EcoVadis",
        },
        {
            key: 1.5,
            title: 'GRI Standards',
            payloadType: "GRI Standards",
        }
    ]
}

const Frameworks = () => {
    const [questionInput, setQuestionInput] = useState("");
    const [presetQuestion, setPresetQuestion] = useState("");
    const [playbookDetails, setPlaybookDetails] = useState({})
    const [activeTab, setActiveTab] = useState("");

    const navigate = useNavigate();

    useEffect(() => {
        const storedTabs = fetchStoredTabs({ playbookName: tabOptions?.title })

        if (storedTabs) {
            const filteredTabOptions = {
                ...tabOptions,
                tabs: tabOptions.tabs.filter(tab => storedTabs?.includes(tab.title))
            };

            setPlaybookDetails(filteredTabOptions)
            setActiveTab(filteredTabOptions?.tabs[0]?.payloadType)
        } else {
            setPlaybookDetails(tabOptions)
            setActiveTab(tabOptions?.tabs[0]?.payloadType)
        }
    }, [setPlaybookDetails, setActiveTab])

    useEffect(() => {
        if (questionInput) {
            navigate(uris.companyResearch, { state: { question: questionInput, presetQuestion: presetQuestion } });
        }
    }, [presetQuestion, questionInput])

    return (
        <div className="frameworks-playbook-container">
            <Breadcrumbs />
            <CustomTab tabOptions={playbookDetails} setTabValue={setActiveTab} tabValue={activeTab}>
                {activeTab && (
                    <div className="playbook-contents">
                        <PlaybookMain
                            promptType={activeTab}
                            setQuestionInput={setQuestionInput}
                            setPresetQuestion={setPresetQuestion}
                        />
                    </div>
                )}
            </CustomTab>
        </div>
    )
}

export default Frameworks;
